import { Injectable } from '@angular/core';
import { JwtHelperService } from '@auth0/angular-jwt';
import { TranslateService } from '@ngx-translate/core';
import { LoginService } from '../views/login/login.service';
import { LoaderService } from '../shared/services/loader.service';
import { BehaviorSubject } from 'rxjs';


@Injectable({
  providedIn: 'root'
})
export class LocalStorageService {

  public translate: TranslateService;
  public permission = new BehaviorSubject([]);
  currentPermissions = this.permission.asObservable();

  constructor(translate: TranslateService, private loginService: LoginService, private loaderService: LoaderService) {
    this.translate = translate;
  }


  changePermission(data: []) {
    this.permission.next(data);
  }

  public getCurrentUser() {
    if (localStorage.getItem('Authorization')) {
      return localStorage.getItem('Authorization');
    } else {
      return null;
    }
  }

  setLanguage(languageCode) {
    this.translate.use(languageCode.toLowerCase());
  }


  getValue(key, languageCode) {
    let value;
    this.translate.use(languageCode.toLowerCase()).subscribe((res) => {
      if (res) {
        value = res[key];
      }
    });
    return value;
  }

  getObject(languageCode) {
    let value;
    this.translate.use(languageCode.toLowerCase()).subscribe((res) => {
      if (res) {
        value = res;
      }
    });
    return value
  }

  public getAccessToken(): string {
    const currentUser = this.getCurrentUser();
    if (currentUser) {
      return currentUser;
    }
    return '';
  }

  public getPermissions() {
    let retrievedData = localStorage.getItem("Permissions");
    let permissions = JSON.parse(retrievedData);
    return permissions;

  }

  public setPermissions(permissions) {
    localStorage.removeItem('Permissions');
    localStorage.setItem('Permissions', JSON.stringify(permissions));
  }





  public setCurrentUser(token) {
    localStorage.removeItem('Authorization');
    localStorage.setItem('Authorization', 'bearer ' + token.access_token);
  }

  public setCurrentUserDetail(token) {
    localStorage.setItem('userId', token.userId);

  }

  public setSelectedLanguageData(data) {
    localStorage.removeItem('selectedLanguage');
    localStorage.setItem('selectedLanguage', JSON.stringify(data));
  }

  public getSelectedLanguageData() {
    if (localStorage.getItem('selectedLanguage')) {
      const retrievedData = localStorage.getItem("selectedLanguage");
      const data = JSON.parse(retrievedData);
      return data;
    } else {
      return null;
    }
  }

  public getSelectedLanguageValue(value) {
    if (localStorage.getItem('selectedLanguage')) {
      const retrievedData = localStorage.getItem("selectedLanguage");
      const data = JSON.parse(retrievedData);
      const index = data.findIndex(res =>
        res.key.replace(/\s/g, '') === value.replace(/\s/g, ''));
      if (index >= 0) {
        return data[index].value;
      }
    } else {
      return null;
    }
  }

  public getCurrentUserDetail() {
    const accesToken = localStorage.getItem('Authorization');
    if (accesToken) {
      const helper = new JwtHelperService();
      const decoded = helper.decodeToken(accesToken);
      return decoded;
    } else if (localStorage.getItem('usedLanguage')) {
      const usedLanguage = localStorage.getItem('usedLanguage');
      const obj = {
        languagecode: usedLanguage
      }
      return obj
    }
    else {
      return null
    }
  }

  public setCurrentUsedLanguage(value) {
    localStorage.removeItem('usedLanguage');
    localStorage.setItem('usedLanguage', value);
  }


  public retreiveDate(data) {
    const offset = new Date().getTimezoneOffset();
    const newdate = new Date(data);
    const date = new Date(newdate.getFullYear(), newdate.getMonth(), newdate.getDate(), 0, offset);
    const getDate = (date.getMonth() + 1) + '/' + date.getDate() + '/' + date.getFullYear() + ' ' +
      date.getHours() + ':' + date.getMinutes() + ':' + date.getSeconds() + ' ' + (date.getHours() > 12 ? 'PM' : 'AM');
    return getDate;
  }

  public removeLogin() {
    // remove user from local storage to log user out
    localStorage.removeItem('Authorization');
    this.removePermission();
  }

  public removePermission() {
    // remove user from local storage to log user out
    localStorage.removeItem('Permissions');
  }

  // logout() {
  //   this.loaderService.showLoader();
  //   this.loginService.logout().subscribe((res: number) => {
  //     this.loaderService.hideLoader();
  //     this.removeLogin();
  //   }, (err) => {
  //     this.loaderService.hideLoader();

  //   });
  // }
}
